import { useEffect, useState } from "react";
import { useCaja } from "../../../contexto/provider/CajaSesionContext.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";
import { ahora } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

import "./form.css";

export default function FormularioAperturaCaja({ onAbierta }) {
  const { abrirCaja, obtenerSesionAbiertaPorDia } = useCaja();
  const [saldoInicial, setSaldoInicial] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [inputsBloqueados, setInputsBloqueados] = useState(false);

  const punto = 101;
  //const hoy = "2026-02-22"; // ejemplo
  const hoy = ahora().split("T")[0];

  useEffect(() => {
    const validarSesion = async () => {
      const sesion = await obtenerSesionAbiertaPorDia({ punto, fecha: hoy });
      if (sesion) {
        setSaldoInicial(sesion.saldoInicial);
        setObservaciones(sesion.observaciones || "");
        setInputsBloqueados(true);
      }
    };
    validarSesion();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!saldoInicial || inputsBloqueados) return;

  const datosAperturaCaja = {
    usuarioId: 1,
    punto,
    fecha: hoy,
    saldoInicial: Number(saldoInicial),
    observaciones,
  };

  console.log("📦 Apertura Caja → payload:", datosAperturaCaja);

  const nuevaSesion = await abrirCaja(datosAperturaCaja);

  console.log("✅ Respuesta abrirCaja:", nuevaSesion);

  onAbierta?.(nuevaSesion);
  setInputsBloqueados(true);
};

  return (
    <div>
      {" "}
      <TituloModulo titulo="Apertura de caja" />
      <div className="form-containere">
        <form onSubmit={handleSubmit} className="grid-caja">
          {/* Fila 1 */}
          <div className="campo-caja">
            <label>Punto</label>
            <div className="valor">{punto}</div>
          </div>

          <div className="campo-caja">
            <label>Fecha</label>
            <div className="valor">{hoy}</div>
          </div>

          {/* Fila 2 */}
          <div className="campo-caja">
            <label>Saldo inicial Efectivo</label>
            <input
              type="text"
              inputMode="numeric"
              placeholder="0"
              disabled={inputsBloqueados}
              value={saldoInicial ? formatearPrecio(saldoInicial) : ""}
              onChange={(e) =>
                setSaldoInicial(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <div className="campo-caja">
            <label>Estado</label>
            <div className="valor">
              {inputsBloqueados ? "Caja abierta" : "Pendiente"}
            </div>
          </div>



          <div className="campo-caja">
            <label>Usuario</label>
            <div className="valor">Admin</div>
          </div>

          {/* Fila 4 (botón ocupa 2 columnas) */}
          <div className="campo-caja campo-accion">
            <BotonAccion type="submit" disabled={inputsBloqueados} 
           > 
              {inputsBloqueados ? "Caja ya abierta" : "Abrir caja"}
            </BotonAccion>
          </div>
        </form>
      </div>
    </div>
  );
}
